/* eslint-disable react/no-direct-mutation-state */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import RegisterFormBanner from './RegisterFormBanner';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import { formFieldConstants } from '../../utils/constants/form-field-constants';
import { formConstants } from '../../utils/constants/form-constants';
import { isEmpty, deepCopyObject } from '../../utils/obj-utils';
import initialState from '../helpers/form-helpers/initial-state';
import FormSpinner from '../../common/utility/FormSpinner';
import FormMessage from '../../common/utility/FormMessage';
import FormBuilder from '../helpers/form-builder';
import * as registerFormActions from '../../../store/actions/register-form-actions';
import * as formStateHelpers from '../helpers/form-helpers/form-state-helper';
import * as formScrollHelpers from '../helpers/form-scroll-helper';
import * as formFieldDisplayHelpers from '../helpers/form-helpers/form-field-display-helpers';
import { findOptionInSelectField } from '../helpers/form-helpers/form-field-helpers';
import SSOFormHeader from '../../common/utility/SSOFormHeader';
import SSOFormFooter from '../../common/utility/SSOFormFooter';
import './one-club-register.scss';
import { getFormDataUrl } from '../../../store/api/api-utils';
import GTMUserActions from '../../common/utility/GTMUserActions';
import { hasValue } from '../../../../../general/js/general-helpers';
import { getFormContainerWideLeftClassList, getModalContentClassListForSSOForm, toggleBemClassesForSSOFormModal } from '../helpers/form-helpers/form-modal-helpers';
import { ssoFormTypes } from '../../utils/form-types';

class OneClubRegisterForm extends Component {
    constructor(props) {
        super(props);

        const { registerFormData, ssoDomain } = this.props;
        this.state = {
            ...initialState.oneClubRegisterFormState,
            registerFormData,
            ssoDomain,
            isModalStylingUpdated: false
        };

        this.formMessageRef = React.createRef();
        this.formReference = React.createRef();
        this.formReferences = formScrollHelpers.getFormReferences(registerFormData);

        this.displayOneClubRegisterForm = this.displayOneClubRegisterForm.bind(this);
        this.displayForm = this.displayForm.bind(this);
        this.loadFormData = this.loadFormData.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleValidationResult = this.handleValidationResult.bind(this);
        this.submitRegisterData = this.submitRegisterData.bind(this);
        this.finalizeSubmitData = this.finalizeSubmitData.bind(this);
        this.handleUserRegisterSuccess = this.handleUserRegisterSuccess.bind(this);
        this.resetForm = this.resetForm.bind(this);

        this.loadFormData();
    }

    loadFormData() {
        const { registerFormData, ssoFormType, actions } = this.props;

        if (!isEmpty(registerFormData)) { return; }

        const formDataUrl = getFormDataUrl(ssoFormType);

        actions.loadSSORegisterFormData(formDataUrl);
    }

    componentDidMount() {
        this.state.isModalStylingUpdated = toggleBemClassesForSSOFormModal(this.formReference, this.props, ssoFormTypes.OneClubRegister);
    }

    componentWillReceiveProps(nextProps) {
        const {
            registerFormData,
            isRegisterSuccessful,
            loading
        } = nextProps;

        const previousRegisterFormData = this.props.registerFormData;

        if (hasValue(registerFormData) && !this.state.isModalStylingUpdated) {
            this.state.isModalStylingUpdated = toggleBemClassesForSSOFormModal(this.formReference, nextProps, ssoFormTypes.OneClubRegister);
        }

        if (!isEmpty(registerFormData) && isEmpty(this.formReferences)) {
            this.formReferences = formScrollHelpers.getFormReferences(registerFormData);
        }

        if (!loading &&
            isRegisterSuccessful) {
            this.setState(formStateHelpers.updateSavingState(false), this.handleUserRegisterSuccess);
            return;
        }

        if (!loading &&
            !isRegisterSuccessful) {
            this.setState(formStateHelpers.updateSavingState(false),
                () => {
                    formScrollHelpers.scrollToField(this.formMessageRef);
                });
        }

        if (isEmpty(previousRegisterFormData) && !isEmpty(registerFormData)) {
            this.setState(
                (prevState) => ({
                    ...prevState,
                    registerFormData
                })
            );
            this.formReferences = formScrollHelpers.getFormReferences(registerFormData);
        }
    }

    componentWillUnmount() {
        this.resetForm();
    }

    resetForm() {
        const { actions } = this.props;
        this.setState(initialState.defaultRegisterFormState);
        actions.resetRegisterFormState();
    }

    handleUserRegisterSuccess() {
        const { onUserRegisterSuccess } = this.props;
        const {
            formType,
            actionSuccessText,
            requestEmailVerificationCallbackUrl,
            requestEmailVerificationActionSuccessText,
            bannerSuccessRegistration
        } = this.props.registerFormData;

        onUserRegisterSuccess(this.state[formConstants.emailAddress],
            {
                registerFormType: formType,
                successText: actionSuccessText,
                emailVerificationCallbackUrl: requestEmailVerificationCallbackUrl,
                emailVerificationActionSuccessText: requestEmailVerificationActionSuccessText,
                bannerSuccessRegistration
            });
    }

    async handleSubmit(event) {
        event.preventDefault();
        const { registerFormData } = this.props;
        const { reCaptcha } = this.state;

        if (reCaptcha) {
            registerFormData.reCaptchaToken = reCaptcha;
        }

        this.setState(formStateHelpers.handleFormValidation(registerFormData), this.handleValidationResult);
    }

    handleValidationResult() {
        if (this.state.formHasErrors) {
            const { errors } = this.state;
            formScrollHelpers.scrollToInvalidField(errors, this.formReferences);
            return;
        }
        const captchaRef = this.formReferences[formConstants.reCaptcha];

        if (captchaRef) {
            captchaRef.current.props.grecaptcha.reset();
        }

        this.setState(formStateHelpers.updateSavingState(true), this.submitRegisterData);
    }

    submitRegisterData() {
        const { registerFormData } = this.props;

        if (registerFormData.membership) {
            this.setState({ membership: registerFormData.membership, ssoEmailNotificationSettingsFields: registerFormData.ssoEmailNotificationSettingsFields }, () => {
                this.finalizeSubmitData();
            });
            return;
        }


        this.finalizeSubmitData();
    }

    finalizeSubmitData() {
        const { actions, registerFormData } = this.props;
        const { callBackUrlPost } = registerFormData;
        const actionSuccessText = registerFormData.actionSuccessText || formMessageConstants.registrationSuccessText;

        formScrollHelpers.scrollToField(this.formReferences[formConstants.title]);
        actions.registerNewUser(this.state, actionSuccessText, callBackUrlPost);
        this.setState({ reCaptcha: '' });

        GTMUserActions.trackJoinTheOneClubAction();
    }

    displayForm() {
        const {
            onSignIn,
            onForgotPassword,
            isRegisterSuccessful,
            userRegistrationMessages,
            registerFormData
        } = this.props;

        const { formHeader } = registerFormData;

        return (<Fragment>
            <SSOFormHeader
                headerTitle={formHeader.headerTitle}
                headerMessage={formHeader.headerMessage}
                headerLinkText={formHeader.headerLinkText}
                headerSecondMessage={formHeader.headerSecondMessage}
                headerSecondLinkText={formHeader.headerSecondLinkText}
                secondLinkCallBackUrl={onForgotPassword}
                linkCallBackUrl={onSignIn}
                displaySecondMessageAndLink={true}></SSOFormHeader>
            <form onSubmit={this.handleSubmit}>
                <FormMessage
                    formRef={this.formMessageRef}
                    isSuccessMessage={isRegisterSuccessful}
                    messages={userRegistrationMessages}></FormMessage>
                {this.displayOneClubRegisterForm()}
                <SSOFormFooter
                    onSubmit={this.handleSubmit}
                    footerButtonText={formMessageConstants.submitOneClubFormButtonText}
                    footerLinkText={`${formMessageConstants.alreadyAMember} ${formMessageConstants.signInHere}`}
                    linkCallBackUrl={onSignIn}></SSOFormFooter>
            </form>
        </Fragment>);
    }

    displayOneClubRegisterForm() {
        const { registerFormData } = this.props;
        const { availableCounties, availableStates } = this.state;
        const { county, mobilePhone, state } = registerFormData;

        const copyOfFormData = deepCopyObject(registerFormData);
        const stateFieldDefaultValue = findOptionInSelectField(copyOfFormData[formConstants.state], this.state[formConstants.state], formFieldConstants.selectFieldOptionsCode);

        copyOfFormData[formConstants.country].defaultValue = this.state[formConstants.country];
        copyOfFormData[formConstants.county].defaultValue = this.state[formConstants.county];
        copyOfFormData[formConstants.state].defaultValue = stateFieldDefaultValue;
        copyOfFormData[formConstants.postcode].defaultValue = this.state[formConstants.postcode];

        return FormBuilder({
            formData: copyOfFormData,
            formReferences: this.formReferences,
            countyData: { availableCounties, label: county ? county.label : '' },
            stateData: { availableStates, label: state ? state.label : '' },
            handleChange: (event) => { this.setState(formStateHelpers.handleFieldChange(event.target)); },
            handleFieldChange: (event) => {
                const eventTarget = event.target;
                const fieldName = eventTarget.name;
                const fieldData = registerFormData[fieldName];
                this.setState(formStateHelpers.handleFieldChangeWithValidation(event.target, fieldData));
            },
            handleConfirmPasswordChange: (event) => { this.setState(formStateHelpers.handleConfirmPasswordFieldChange(event.target)); },
            handleDateChange: (event) => { this.setState(formStateHelpers.handleDateChange(event)); },
            handleCountryChange: (event) => { this.setState(formStateHelpers.handleCountryChange(event.target, county, state)); },
            handleMobilePhoneChange: (event) => { this.setState(formStateHelpers.handleMobilePhoneChange(event, mobilePhone.isOptional)); },
            handleCaptchaChange: (token) => { this.setState(formStateHelpers.handleCaptchaChange(token)); },
            handleMastercardNumberChange: (event) => {
                this.setState(formStateHelpers.handleMastercardNumberChange(event.target,
                    registerFormData.mastercardRegex, registerFormData.mastercardValidationError));
            },
            handleFieldValidState: (fieldName) => { const { errors } = this.state; return formFieldDisplayHelpers.handleFieldValidState(fieldName, errors); },
        });
    }

    render() {
        const { isSaving } = this.state;
        const { loading, registerFormData } = this.props;

        if (isEmpty(registerFormData)) {
            return (
                <div ref={this.formReference}/>
            );
        }

        const { formBanner, desktopImageSrc, mobileImageSrc } = registerFormData;

        return (
            <div ref={this.formReference} className={getModalContentClassListForSSOForm(this.props)}>
                <div className={getFormContainerWideLeftClassList(this.props)}>
                    {
                        hasValue(mobileImageSrc) &&
                        <div>
                            <img src={mobileImageSrc} className='form-container__banner--mobile' data-sizes="auto" />
                        </div>
                    }
                    <RegisterFormBanner
                        formBanner={formBanner}
                    ></RegisterFormBanner>
                    <div className='form-container__form'>
                        {isSaving || loading ? <FormSpinner spinnerRef={this.spinnerRef}>/</FormSpinner> : null}
                        {this.displayForm()}
                    </div>
                </div>
                {
                    hasValue(desktopImageSrc) &&
                    <div className='form-container__wide--right'>
                        <img src={desktopImageSrc} className='form-container__banner--desktop' data-sizes="auto" />
                    </div>
                }
            </div >
        );
    }
}

OneClubRegisterForm.propTypes = {
    loading: PropTypes.bool.isRequired,
    onSignIn: PropTypes.func.isRequired,
    onUserRegisterSuccess: PropTypes.func.isRequired,
    ssoDomain: PropTypes.string,
    registerFormData: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        registerFormData: _isEmpty(ownProps.registerFormData) ? state.registerForm.registerFormData : ownProps.registerFormData,
        isRegisterSuccessful: state.registerForm.isRegisterSuccessful,
        userRegistrationMessages: state.registerForm.userRegistrationMessages,
        userName: state.registerForm.userName,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            registerNewUser: bindActionCreators(registerFormActions.registerNewUser, dispatch),
            resetRegisterFormState: bindActionCreators(registerFormActions.resetRegisterFormState, dispatch),
            loadSSORegisterFormData: bindActionCreators(registerFormActions.loadSSOOneClubRegisterFormData, dispatch),
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OneClubRegisterForm);
